import * as TypeStyle from 'typestyle';

export const TextColors = {
  Primary: '#2e2e2e',
  Neutral: '#5c5c5c',
  Disabled: '#c9c9c9',
  Error: '#ba0517',
  Valid: '#22683e',
};

// Content of a list item is customer controlled (and it's not necessarily just text).
// The expectation for disabled items is that everything (including icons) looks "grayed out".
// To achieve this automatically (without the customer having to gray it out themselves),
// opacity is added to disabled items. Thus the grays used for disabled items have to be adjusted
// so that they render as the spec'd color with the opacity.
export const ListAndMenuColors = {
  Active: '#e5e5e5', // 229
  ActiveBorder: '#939393', // 147
  DisabledBorder: '#040404', // hack to show as `ActiveBorder` when opacity is 0.43
  DisabledText: '#c9c9c9',
  DisabledTextWithOpacity: '#828282', // hack to show as `DisabledText when opacity is 0.43
  Hover: '#e5e5e5', // 229
  Opacity: 0.43,
  Press: '#c9c9c9',
  Text: '#444444', // 68
};

export const TextFieldBorderColors = {
  Rest: '#747474', // component/border/outline/on-light/default
  Disabled: '#c9c9c9',
  Error: '#ba0517',
  Valid: '#22683e',
};

export const InvertTextColors = {
  Primary: '#fff',
  Secondary: 'rgba(255, 255, 255, 0.96)',
  Netural: 'rgba(255, 255, 255, 0.56)',
  Disabled: 'rgba(255, 255, 255, 0.35)',
};

export const InvertBorderColors = {
  Rest: '#aeaeae', // component/content/outline/on-dark/default
  Disabled: '#747474', // component/content/outline/on-dark/disabled
};

export const TextFieldHoverColor = '#e5e5e5';

export const InteractiveBorderColors: TypeStyle.types.NestedCSSProperties = Object.freeze({
  borderColor: TextFieldBorderColors.Rest,
  $nest: {
    '&:disabled': { borderColor: `${TextFieldBorderColors.Disabled}` },
  }
});

export const InvertInteractiveBorderColors: TypeStyle.types.NestedCSSProperties = Object.freeze({
  borderColor: InvertBorderColors.Rest,
  $nest: {
    '&:disabled': { borderColor: `${InvertBorderColors.Disabled}` },
  }
});
